import BetaMessage from "@/components/BetaMessage/BetaMessage";
import { ImpactDataset, useGetEcoInventSuggestions } from "@/hooks/useEcoInventDatasets";
import useTranslation from "@/hooks/useTranslation";

import DatasetTable, { datasetTableColumns } from "@/components/DatasetTable/DatasetTable";
import { Column } from "@/components/Table/Table";
import styles from "@/pages/materials/MaterialImpactModal/MaterialImpactReferenceModal.module.scss";
import { Tag } from "antd";
import Link from "antd/es/typography/Link";
import { tabItems } from "./ImpactReferencePageTabs";

export interface MaterialImpactReferenceSuggestionsProps {
  materialIds: number[];
  selectedDataset?: ImpactDataset;
  onDatasetChange: (id: ImpactDataset) => void;
  setActiveTab: (tab: string) => void;
}

export const EcoInventSuggestions = ({
  materialIds,
  selectedDataset,
  onDatasetChange,
  setActiveTab,
}: MaterialImpactReferenceSuggestionsProps) => {
  const suggestionsDisabled = materialIds.length !== 1;
  const materialId = !suggestionsDisabled ? materialIds[0] : 0;
  const translation = useTranslation();

  const { data, isLoading, isFetching } = useGetEcoInventSuggestions({
    materialId: materialId,
    enabled: !suggestionsDisabled,
  });

  const columns: Column<ImpactDataset>[] = [
    {
      key: "score",
      label: "score",
      maxWidth: "80px",
      minWidth: "80px",
      renderer: (record) =>
        record.confidence ? <Tag>{Math.round(record.confidence * 100)}%</Tag> : <Tag>0%</Tag>,
    },
    ...datasetTableColumns,
  ];

  const changeTab = () => {
    setActiveTab(tabItems.ecoinvent.key);
  };

  return (
    <>
      <BetaMessage
        title={
          <span dangerouslySetInnerHTML={{ __html: translation.impactReferenceModal.beta.title }} />
        }
      >
        {translation.impactReferenceModal.beta.message}
      </BetaMessage>
      <div className={styles.form}>
        <DatasetTable
          loading={!suggestionsDisabled && (isLoading || isFetching)}
          data={data?.suggestions}
          onRowClick={(record) => onDatasetChange(record)}
          activeRowKey={selectedDataset?.id}
          columns={columns}
          emptyState={{
            noResultsMessage: suggestionsDisabled ? (
              <span>
                {
                  "Suggestions are not available because multiple materials are selected, please check the "
                }
                <Link onClick={changeTab}>Full database</Link>
              </span>
            ) : (
              <span>No suggestions for this material.</span>
            ),
          }}
        />
      </div>
    </>
  );
};
